
export default {
  props: {
    text: {
      default: "",
    },
    htmlContent: {
      default: "",
    },
    //可选项: "Light","Dark"
    theme: {
      default: "Light"
    }
  }
};
